export function deleteLabel(applet, user) {
  return applet.author === user.login ? "Archive" : "Delete"
}

export function ctaCopyToConnect(shortName) {
  return shortName ? `Connect ${shortName}` : "Connect"
}
